import HamburgerMenu from "./component/hamburgerMenu";
import SmoothScroll from "./component/smoothScroll";
import PageTop from "./component/pageTop";
import Slider from "./component/slider";


window.addEventListener("load", () => {
  new HamburgerMenu().handleClick("js-hamburger");
  new SmoothScroll();
  new Slider();
  new PageTop();
});


